var viewport = {
    selector: '[data-viewport]',
    init: function () {
        var self = this,
            $elements = $(self.selector);

        setTimeout(function () {
            $elements.viewportChecker({
                classToAdd: 'visible',
                classToAddForFullView: 'full-visible',
                classToRemove: 'invisible',
                removeClassAfterAnimation: false,
                invertBottomOffset: true,
                repeat: false,
                scrollHorizontal: false,
            });
        }, 100);
    },
};

export { viewport };
